import {
  Center,
  Empty,
  EmptyHeadline,
  EmptyDrawerIcon,
} from '@frontend/components';

export const NoFileToDisplayScreen = () => (
  <Center h="100%">
    <Empty size="lg">
      <EmptyDrawerIcon />
      <EmptyHeadline>No file to display</EmptyHeadline>
    </Empty>
  </Center>
);
